import "../../components/welcomeScreen/welcomeWizard.scss";
import "./syncSettings.scss";

import PropTypes from "prop-types";
import React from "react";

import FormButton from "../../components/form/FormButton";
import Icon from "../../components/interface/Icon";
import ModalBody from "../../components/modal/ModalBody";
import ModalDescription from "../../components/modal/ModalDescription";
import ModalField from "../../components/modal/ModalField";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalRow from "../../components/modal/ModalRow";
import pathUtils from "../../utils/pathUtils";

const SyncScrivenerPreconfiguredPage = props => {
  const label = props.hasExternalRep ? "Your timeline is being synced with:" : "Scrivener project not found";
  return (
    <ModalBody key="content">
      <ModalGroup label={label} className="syncPreconfiguredModalGroup">
        <ModalRow>
          <ModalField flex={0}>
            <Icon className="syncAppIcon" icon="scrivener" color="iconSoften" />
          </ModalField>
          <ModalField flex={0}>
            <div className="syncPathDiv">
              <div>
                <div className="syncPathFilename">
                  <FormButton
                    linkStyle={true}
                    label={pathUtils.fileNameFromPath(props.path)}
                    onClick={props.onProjectLinkClick}
                  />
                </div>
                <div className="syncPathDirectory">
                  <span className="syncDirectoryPath">{pathUtils.directoryFromPath(props.path)}</span>
                </div>
              </div>
              <div className="syncReplacePath">
                <FormButton label="My project has moved" onClick={props.onBrowseClick} />
              </div>
            </div>
          </ModalField>
        </ModalRow>
        {!props.hasExternalRep ? (
          <ModalRow>
            <ModalDescription>
              <span className="warning">
                No Scrivener project could be loaded from the above path. Syncing will be disabled until the Scrivener
                project is reinstated or the path updated.
              </span>
            </ModalDescription>
          </ModalRow>
        ) : null}
      </ModalGroup>
    </ModalBody>
  );
};

SyncScrivenerPreconfiguredPage.propTypes = {
  path: PropTypes.string,
  hasExternalRep: PropTypes.bool.isRequired,
  settingsChanged: PropTypes.bool.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onBrowseClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onProjectLinkClick: PropTypes.func.isRequired
};

export default SyncScrivenerPreconfiguredPage;
